export default __webpack_public_path__ + "static/media/feather_ham.a7e0932b.svg";